var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneOnOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "one-on-one"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29993",
    "data-name": "Rectangle 29993",
    width: 16,
    height: 16,
    transform: "translate(26 261)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_839",
    "data-name": "Mask Group 839",
    transform: "translate(-26 -261)",
    clipPath: "url(#one-on-one)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-06-16T121618.221",
    "data-name": "svgexport-6 - 2022-06-16T121618.221",
    transform: "translate(26 261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27516",
    "data-name": "Path 27516",
    d: "M7.667,11.333h.667V16H7.667Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27517",
    "data-name": "Path 27517",
    d: "M3,10H13v.667H3Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27518",
    "data-name": "Path 27518",
    d: "M14.333,5.667A1.667,1.667,0,1,1,16,4,1.669,1.669,0,0,1,14.333,5.667Zm0-2.667a1,1,0,1,0,1,1A1,1,0,0,0,14.333,3Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27519",
    "data-name": "Path 27519",
    d: "M11,16a.327.327,0,0,1-.131-.027.333.333,0,0,1-.175-.438l1-2.333A.333.333,0,0,1,12,13h2.333a1,1,0,0,0,1-1V7.667A.667.667,0,0,0,14.667,7h-.333c-.234,0-.447.155-.734.535-.322.425-1.3,1.625-1.341,1.676A.334.334,0,0,1,12,9.333H10.333A.333.333,0,0,0,10,9.667v.667a.333.333,0,0,1-.667,0V9.667a1,1,0,0,1,1-1h1.508c.263-.324.971-1.2,1.226-1.534a1.654,1.654,0,0,1,1.266-.8h.333A1.335,1.335,0,0,1,16,7.667V12a1.669,1.669,0,0,1-1.667,1.667H12.22L11.306,15.8A.333.333,0,0,1,11,16Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27520",
    "data-name": "Path 27520",
    d: "M9.667,16a.334.334,0,0,1-.316-.439l1.105-3.316a1.331,1.331,0,0,1,1.265-.911h.946v-1a.333.333,0,0,1,.667,0v1.333A.333.333,0,0,1,13,12H11.721a.665.665,0,0,0-.632.455L9.983,15.772A.334.334,0,0,1,9.667,16Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27521",
    "data-name": "Path 27521",
    d: "M13,10.667a.333.333,0,0,1-.266-.533l1-1.333a.333.333,0,0,1,.533.4l-1,1.333a.331.331,0,0,1-.267.133Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27522",
    "data-name": "Path 27522",
    d: "M1.667,5.667A1.667,1.667,0,1,1,3.333,4,1.669,1.669,0,0,1,1.667,5.667ZM1.667,3a1,1,0,1,0,1,1A1,1,0,0,0,1.667,3Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27523",
    "data-name": "Path 27523",
    d: "M5,16a.333.333,0,0,1-.306-.2L3.78,13.667H1.667A1.669,1.669,0,0,1,0,12V7.667A1.335,1.335,0,0,1,1.333,6.333h.333a1.652,1.652,0,0,1,1.266.8c.256.338.963,1.211,1.226,1.534H5.667a1,1,0,0,1,1,1v.667a.333.333,0,0,1-.667,0V9.667a.334.334,0,0,0-.333-.333H4a.333.333,0,0,1-.258-.123C3.7,9.16,2.723,7.96,2.4,7.534,2.114,7.155,1.9,7,1.667,7H1.333a.667.667,0,0,0-.667.667V12a1,1,0,0,0,1,1H4a.333.333,0,0,1,.306.2l1,2.333a.333.333,0,0,1-.175.438A.327.327,0,0,1,5,16Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27524",
    "data-name": "Path 27524",
    d: "M6.333,16a.334.334,0,0,1-.316-.228L4.912,12.456A.666.666,0,0,0,4.279,12H3a.333.333,0,0,1-.333-.333V10.333a.333.333,0,0,1,.667,0v1h.946a1.332,1.332,0,0,1,1.265.911L6.65,15.561A.334.334,0,0,1,6.333,16Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27525",
    "data-name": "Path 27525",
    d: "M3,10.667a.333.333,0,0,1-.267-.133l-1-1.333a.333.333,0,0,1,.533-.4l1,1.333A.333.333,0,0,1,3,10.667Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27526",
    "data-name": "Path 27526",
    d: "M6.333,7.333A.333.333,0,0,1,6,7V5.667a.333.333,0,0,1,.667,0V6.2l.764-.764a.332.332,0,0,1,.236-.1H11A.334.334,0,0,0,11.333,5V1A.334.334,0,0,0,11,.667H5A.334.334,0,0,0,4.667,1V5A.334.334,0,0,0,5,5.333.333.333,0,1,1,5,6,1,1,0,0,1,4,5V1A1,1,0,0,1,5,0h6a1,1,0,0,1,1,1V5a1,1,0,0,1-1,1H7.8L6.569,7.236a.333.333,0,0,1-.236.1Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27527",
    "data-name": "Path 27527",
    d: "M9,2.667h.667v.667H9Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27528",
    "data-name": "Path 27528",
    d: "M7.667,2.667h.667v.667H7.667Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27529",
    "data-name": "Path 27529",
    d: "M6.333,2.667H7v.667H6.333Zm0,0",
    fill: "#8391a2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOnOne);
export default __webpack_public_path__ + "static/media/one-on-one.da4b1607cf4d72bc19ebd4af1ffe424f.svg";
export { ForwardRef as ReactComponent };